<template>
    <v-tab-item :key="'user'">
        <br/>

        <v-list subheader v-if="usuarios && usuarios.length">

            <template v-for="item in usuarios">
                <v-list-tile avatar :key="item.numero">
                    <v-list-tile-avatar>
                        {{item.usuario}}
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-sub-title v-html="item.nome"/>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="item.numero"/>
            </template>

        </v-list>

        <v-container fluid v-if="!usuarios || !usuarios.length">
            <v-chip color="indigo" text-color="white" style="width: 100%" >
                <v-avatar>
                    <v-icon>perm_identity</v-icon>
                </v-avatar>
                NENHUMA USUÁRIO
            </v-chip>
        </v-container>

    </v-tab-item>
</template>

<script>
    export default {
        name: "list-usuarios",
        props: {
            usuarios: {
                default: []
            }
        }
    };
</script>

<style scoped>

</style>
